import { bus } from '@/consts.js'

export default {
  name: 'MobileDrawerButton',
  template: '#mobiledrawer-template',
  methods: {
    open () {
      bus.$emit('mobileDrawerOpen')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/MobileDrawerButton.js